module.exports = __webpack_public_path__ + "static/media/2020.8.21 党员环境整治活动.4fd0f4ab.jpg";